const formatErrorDetail = (error: any) => {
  if (typeof error === 'string') {
    return JSON.stringify(error)
  }
  if (error && error.stack) {
    return JSON.stringify({
      name: error.name,
      message: error.message,
      stack: error.stack,
    })
  }
  // 支持嵌套 error
  if (error && error.error && error.error.stack) {
    return JSON.stringify({
      ...error,
      error: {
        name: error.error.name,
        message: error.error.message,
        stack: error.error.stack,
      },
    })
  }
  return JSON.stringify(error)
}

/**
 * 手动上报错误
 *
 * @param detail 可以直接丢一个 `Error`，当然如果你还需要额外携带其他信息，可以把 `Error` 放到 `error` 这个属性上。
 */
export const sentryReport = (message: string, detail: any, tag: string) => {
  if (!window.Sentry) {
    console.log('Sentry is not defined', { message, detail, tag })
    return
  }
  window.Sentry.captureMessage(String(message), (scope: any) => {
    scope.setTag('report-type', 'shared-sentry-report')
    scope.setTag('sentry-report-util', tag)
    scope.setExtra('detail', formatErrorDetail(detail))
  })
}

export const sentryBreadcrumb = (data: {
  category: string
  message?: string
  data?: Record<string, any>
  level?: string
}) => {
  if (!window.Sentry) {
    console.log('Sentry is not defined', data)
    return
  }
  data.level = data.level || window.Sentry.Severity.Info
  window.Sentry.addBreadcrumb(data)
}
